import { Card, CardBody, CardHeader } from "../../../_metronic/_partials/controls"
import { RowModule } from "../../atoms/RowModule/RowModule.jsx"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect, useState, useRef } from "react"
import {
  fetchDistrictByRegencyId,
  fetchProvince,
  fetchProvinceByRegional,
  fetchRegencyByProvinceId,
  fetchSubDistrictByDistrictId
} from "../../../redux/actions/MasterDataAction"
import { TextAreaInput, TextInput } from "../../atoms/TextInput"
import { SelectInput } from "../../atoms/SelectInput"
import { useFormikContext } from "formik"
import { renderLabelRequired } from "../../../app/helpers/FormikHelper"
import { useTranslation } from "react-i18next"

export const AddressMolecule = ({
  name,
  addressTitle,
  isReadOnly,
  removeHorizontalPadding = false,
  removeTitleSeparator = false,
  withoutAddress = false,
  byRegional = false,
  regionalId,
  isChangeRegional
}) => {
  const { values: formValues } = useFormikContext()

  const dispatch = useDispatch()
  const { MasterData } = useSelector((state) => state)
  const { t } = useTranslation()
  const [provinceList, setProvinceList] = useState([])
  const [regencyList, setRegencyList] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [subDistrictList, setSubDistrictList] = useState([])
  const [masterSubDistrictList, setMasterSubDistrictList] = useState([])
  const [province, setProvince] = useState(formValues[name + "Province"] || "")
  const [regency, setRegency] = useState(formValues[name + "Regency"] || "")
  const [district, setDistrict] = useState(formValues[name + "District"] || "")
  const [subDistrict, setSubDistrict] = useState(formValues[name + "SubDistrict"] || "")
  const [postalCode, setPostalCode] = useState(formValues[name + "PostalCode"] || "")
  const [isChangeProvince, setIsChangeProvince] = useState(false)
  const [isRegency, setIsRegency] = useState(false)
  const [isDistrict, setIsDistrict] = useState(false)
  const [provinceDisable, setProvinceDisable] = useState(false)
  const prevRegionalId = useRef(regionalId)
  const initialLoadDone = useRef(false)

  useEffect(() => {
    if (byRegional && formValues["regionalId"]) {
      dispatch(fetchProvinceByRegional(formValues["regionalId"]))
    } else {
      dispatch(fetchProvince())
    }

  }, []) 

  useEffect(() => {
    if (byRegional && formValues["regionalId"]) {
      dispatch(fetchProvinceByRegional(formValues["regionalId"]))
    } else if (!byRegional) {
      dispatch(fetchProvince())
    }

    if (regionalId && isChangeRegional && prevRegionalId.current !== regionalId) {
      resetAll()
      prevRegionalId.current = regionalId
    }
  }, [byRegional, formValues["regionalId"], regionalId, isChangeRegional])

  useEffect(() => {
    if (!initialLoadDone.current) {
      if (formValues[name + "Province"]) {
        setProvince(formValues[name + "Province"])
        dispatch(fetchRegencyByProvinceId(formValues[name + "Province"]))
      }

      initialLoadDone.current = true
    }
  }, [])

  useEffect(() => {
    if (province) {
      dispatch(fetchRegencyByProvinceId(province))
    }
  }, [province])

  useEffect(() => {
    if (regency) {
      dispatch(fetchDistrictByRegencyId(regency))
    }
  }, [regency])

  useEffect(() => {
    if (district) {
      dispatch(fetchSubDistrictByDistrictId(district))
    }
  }, [district])

  useEffect(() => {
    if (formValues[name + "Province"] !== undefined) {
      setProvince(formValues[name + "Province"])
    }
  }, [formValues[name + "Province"]])

  useEffect(() => {
    if (formValues[name + "Regency"] !== undefined) {
      setRegency(formValues[name + "Regency"])
    }
  }, [formValues[name + "Regency"]])

  useEffect(() => {
    if (formValues[name + "District"] !== undefined) {
      setDistrict(formValues[name + "District"])
    }
  }, [formValues[name + "District"]])

  useEffect(() => {
    if (formValues[name + "SubDistrict"] !== undefined) {
      setSubDistrict(formValues[name + "SubDistrict"])
    }
  }, [formValues[name + "SubDistrict"]])

  useEffect(() => {
    if (formValues[name + "PostalCode"] !== undefined) {
      setPostalCode(formValues[name + "PostalCode"])
    }
  }, [formValues[name + "PostalCode"]])

  useEffect(() => {
    if (MasterData.provinceList) {
      setProvinceList(
        MasterData.provinceList.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [MasterData.provinceList])

  useEffect(() => {
    if (MasterData.regencyList && MasterData.regencyList.length > 0) {
      setRegencyList(
        MasterData.regencyList.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )

      if (isChangeProvince) {
        setRegency("")
        setDistrict("")
        setSubDistrict("")
        setPostalCode("")
        setIsChangeProvince(false)
      }
    }
  }, [MasterData.regencyList])

  useEffect(() => {
    if (MasterData.districtList && MasterData.districtList.length > 0) {
      setDistrictList(
        MasterData.districtList.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )

      if (isRegency) {
        setDistrict("")
        setSubDistrict("")
        setPostalCode("")
        setIsRegency(false)
      }
    }
  }, [MasterData.districtList])

  useEffect(() => {
    if (MasterData.subDistrictList && MasterData.subDistrictList.length > 0) {
      setMasterSubDistrictList(MasterData.subDistrictList)
      setSubDistrictList(
        MasterData.subDistrictList.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )

      if (isDistrict) {
        setSubDistrict("")
        setPostalCode("")
        setIsDistrict(false)
      }
    }
  }, [MasterData.subDistrictList])

  useEffect(() => {
    setProvinceDisable(byRegional ? !!formValues["regionalId"] : !isReadOnly)
  }, [byRegional, formValues["regionalId"], isReadOnly])

  function onChangeProvince(e) {
    setProvince(e || "")
    setIsChangeProvince(true)
  }

  function onChangeRegency(e) {
    setRegency(e || "")
    setIsRegency(true)
  }

  function onChangeDistrict(e) {
    setDistrict(e || "")
    setIsDistrict(true)
  }

  function onChangeSubDistrict(e) {
    if (e) {
      const selectSubdistrict = masterSubDistrictList.find((el) => el.id === e)
      if (selectSubdistrict) {
        setSubDistrict(e)
        setPostalCode(selectSubdistrict.postal_code)
      }
    } else {
      setSubDistrict("")
      setPostalCode("")
    }
  }

  const isRegencyEnabled = () => {
    if (!isReadOnly) {
      return regencyList.length !== 0
    }
    return !isReadOnly
  }

  const isDistrictEnabled = () => {
    if (!isReadOnly) {
      return districtList.length !== 0
    }
    return !isReadOnly
  }

  const isSubDistrictEnabled = () => {
    if (!isReadOnly) {
      return subDistrictList.length !== 0
    }
    return !isReadOnly
  }

  const resetAll = () => {
    setProvince("")
    setDistrict("")
    setRegency("")
    setSubDistrict("")
    setRegencyList([])
    setDistrictList([])
    setSubDistrictList([])
    setPostalCode("")
    setIsChangeProvince(false)
    setIsRegency(false)
    setIsDistrict(false)
  }

  return (
    <>
      <Card className="card-custom card-shadowless">
        { addressTitle && (
          <CardHeader
            title={addressTitle}
            className={[
              removeHorizontalPadding ? "px-0" : "",
              removeTitleSeparator ? "border-bottom-0" : ""
            ].join(" ")}
          />
        )
        }
        <CardBody className={removeHorizontalPadding ? "px-0" : ""}>
          <RowModule>
            <SelectInput
              name={name + "Province"}
              onChange={onChangeProvince}
              label={renderLabelRequired(t("label_province"))}
              placeholder={t("placeholder_choose_province")}
              value={province}
              editable={provinceDisable}
              options={provinceList}
            />

            <SelectInput
              name={name + "Regency"}
              onChange={onChangeRegency}
              label={renderLabelRequired(t("label_city"))}
              editable={isRegencyEnabled()}
              placeholder={t("placeholder_choose_city")}
              value={regency}
              options={regencyList}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name={name + "District"}
              onChange={onChangeDistrict}
              editable={isDistrictEnabled()}
              label={renderLabelRequired(t("label_district"))}
              placeholder={t("placeholder_choose_district")}
              value={district}
              options={districtList}
            />

            <SelectInput
              name={name + "SubDistrict"}
              onChange={onChangeSubDistrict}
              editable={isSubDistrictEnabled()}
              label={renderLabelRequired(t("label_subdistrict"))}
              placeholder={t("placeholder_choose_subdistrict")}
              value={subDistrict}
              options={subDistrictList}
            />
          </RowModule>
          <RowModule customColumnCss=" col-lg-6 col-sm-6 col-md-6">
            <TextInput
              editable={false}
              label={t("label_postal_code")}
              required
              name={name + "PostalCode"}
              value={postalCode}
              placeholder={t("label_postal_code")}
            />
          </RowModule>
          {!withoutAddress && (
            <RowModule>
              <TextAreaInput
                editable={isReadOnly}
                label={renderLabelRequired(t("label_full_address"))}
                name={name + "Address"}
                placeholder={t("label_full_address")}
              />
            </RowModule>
          )}
        </CardBody>
      </Card>
    </>
  )
}

export * from "./addressTab"